import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';
import { SMALL_SCALE } from '../../BSLAConstants';

const BSLAFloodLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        title: 'FEMA FLood Zones',
        minScale: SMALL_SCALE,
        visible: false,
        portalItem: {
            id: '2b245b7f816044d7a779a61a5844be23'
        },
        popupTemplate: {
            outFields: ['*'],
            title: 'FEMA Flood Zones',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');

                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Flood Zone" value={atts.FLD_ZONE} />
                        <BSLAPopupItemComponent label="Flood Area ID" value={atts.FLD_AR_ID} />
                        <BSLAPopupItemComponent label="DFIRM ID" value={atts.DFIRM_ID} />
                        <BSLAPopupItemComponent label="Base Flood Elevation" value={atts.STATIC_BFE === -9999 ? 'N/A' : atts.STATIC_BFE} />
                        <p className="mt-3">
                            Issue: This layer shows the mapped 100 year floodplain as determined by the Federal Emergency Management Agency (FEMA). Development in the 100 year
                            floodplain may require elevated building pads or the excavation of non-floodplain portions of the development site to offset fill in the floodplain.
                        </p>
                        <p>
                            Cost: This issue can limit the development potential of a site or result in additional fill costs to raise building pads. Typically, portions of the
                            site above the floodplain can be excavated to create flood storage areas, and in some cases, land nearby the development site can be purchased and
                            excavated to create storage.
                        </p>
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });

    // return new MapImageLayer({
    //     url: 'https://hazards.fema.gov/gis/nfhl/rest/services/public/NFHL/MapServer',
    //     visible: false,
    //     minScale: 50000,
    //     listMode: 'hide-children',
    //     opacity: 0.5,
    //     title: 'FEMA Flood Zones',
    //     sublayers: [
    //         {
    //             id: 28,
    //             definitionExpression: "FLD_ZONE <> 'X'",
    //             popupTemplate: {
    //                 outFields: ['*'],
    //                 content: (feature: __esri.Feature) => {
    //                     const atts = feature.graphic.attributes;
    //                     const node = document.createElement('div');

    //                     const content = (
    //                         <React.Fragment>
    //                             <BSLAPopupItemComponent label="Flood Zone" value={atts.FLD_ZONE} />
    //                             <BSLAPopupItemComponent label="Flood Area ID" value={atts.FLD_AR_ID} />
    //                             <BSLAPopupItemComponent label="DFIRM ID" value={atts.DFIRM_ID} />
    //                             <BSLAPopupItemComponent label="Base Flood Elevation" value={atts.STATIC_BFE === -9999 ? 'N/A' : atts.STATIC_BFE} />
    //                             <hr />
    //                             <small>
    // <p>
    //     Issue: This layer shows the mapped 100 year floodplain as determined by the Federal Emergency Management Agency (FEMA). Development in the
    //     100 year floodplain may require elevated building pads or the excavation of non-floodplain portions of the development site to offset fill
    //     in the floodplain.
    // </p>
    // <p>
    //     Cost: This issue can limit the development potential of a site or result in additional fill costs to raise building pads. Typically,
    //     portions of the site above the floodplain can be excavated to create flood storage areas, and in some cases, land nearby the development
    //     site can be purchased and excavated to create storage.
    // </p>
    //                             </small>
    //                         </React.Fragment>
    //                     );

    //                     ReactDOM.render(content, node);

    //                     return node;
    //                 }
    //             }
    //         }
    //     ]
    // });
};

export default BSLAFloodLayer;
